import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../core/auth/auth.service";
import {NgForm} from "@angular/forms";
import {LoginPassword} from "../../core/auth/login-password";
import {Router} from "@angular/router";
import * as _ from 'lodash';
import {HttpErrorResponse} from "@angular/common/http";
import {LoginService} from "./login.service";
import {LoginResponse} from "./login-response";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginError = false;
  loginErrorMessage = "";

  constructor(private authService: AuthService,
              private router: Router,
              private loginService: LoginService) {
  }

  ngOnInit() {
    this.authService.isSessionValid().subscribe(() => {
      this.router.navigate(['/ganalottodo']);
    });
  }

  login(form: NgForm) {
    console.log("LoginComponent:login", form);
    const loginPassword = new LoginPassword(form.value.email, form.value.password);
    this.loginService.signIn(loginPassword).subscribe((loginResponse: LoginResponse) => {
      if (loginResponse.isSuccess) {
        this.router.navigate(['/ganalottodo']);
      } else {
        this.loginError = true;
        this.loginErrorMessage = loginResponse.message;
      }
    }, (error: LoginResponse) => {
      this.loginError = true;
      this.loginErrorMessage = error.message;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/login/login.component.ts